export const dashboardImageConstants = {
  GETALL_REQUEST: "DASHBOARD_IMAGE_GETALL_REQUEST",
  GETALL_SUCCESS: "DASHBOARD_IMAGE_GETALL_SUCCESS",
  GETALL_FAILURE: "DASHBOARD_IMAGE_GETALL_FAILURE",

  LOADING_REQUEST: "LOADING_REQUEST",
};
